/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowPolicyMapping extends models.ServiceNowMappingBase {
    getFixupPrototypeFunction() { return ServiceNowPolicyMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowPolicyMapping>): ServiceNowPolicyMapping {
        let obj = Object.assign(new ServiceNowPolicyMapping(), model);
        ServiceNowPolicyMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowPolicyMapping>): ServiceNowPolicyMapping {
        if (!model) return null;
        return ServiceNowPolicyMapping.newInstance(<ServiceNowPolicyMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowPolicyMapping) {
        if (!obj) return;

        models.ServiceNowPolicyMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowPolicyMapping): boolean {
        if (models.ServiceNowMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowPolicyMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    description_attributes: Array<models.ServiceNowPolicyDescriptionAttribute>;

}
